import React from "react";
import './App.css';
import { SelectSection } from "./SelectSection.js";
import { PreviewBox } from "./PreviewBox.js";
import { Lightbox } from "./Lightbox.js";

import styles from "./styles";
import CurrencySelector from "./CurrencySelector.js";


class App extends React.Component {
	
	constructor(props){
		super(props);
		
		this.state = {
			selectedStyle: "surprise_me",
			selectedVar: 1,
			selectedDetail: 0,
			charCount: 1,
			price: 50,
			lightboxOpen: false,
			currency: "USD",
			rate: 1
		};
		
		this.setSelected = this.setSelected.bind(this);
		this.setCurrencyAndRate = this.setCurrencyAndRate.bind(this);
		this.getPrice = this.getPrice.bind(this);
		this.toggleLightbox = this.toggleLightbox.bind(this);
	}
	
	render() {
		const thisStyle = styles[this.state.selectedStyle];
		const thisVariant = this.state.selectedStyle ? (
			this.state.selectedVar !== null ? thisStyle.variants[this.state.selectedVar] : null
		) : null;

		let imgsrc = this.state.selectedStyle ? (
			thisVariant && thisVariant.images ?
				(thisVariant.images[0].full) : 
				(thisStyle.display_image?.full || null)
			) : null;

		return (
			<div className="App">
				<PreviewBox
					src={ imgsrc }
					charCount={ this.state.charCount }
					onClick={ this.toggleLightbox }
					hasMultipleImages={ thisVariant?.images?.length > 1 }
				/>
				
				<CurrencySelector
					currency={ this.state.currency }
					setSelected={ this.setSelected }
					setCurrencyAndRate={this.setCurrencyAndRate} />
				
				<SelectSection
					handleChange={this.setSelected}
					options={styles}
					appState={ { ...this.state } } />
				
				{
					this.state.lightboxOpen ? (
						<Lightbox
							onClick={this.toggleLightbox}
							src={ imgsrc }
							styleName={thisStyle.name}
							variantName={this.state.selectedVar ? thisStyle.variants[this.state.selectedVar].name : null}
							images={ thisVariant?.images || [ thisStyle.display_image ] }
						/>
					) : ""
				}
					
			</div>
		);
	}

	setSelected(attr, val) {
		var newstate = (
			({ selectedStyle, selectedVar, selectedDetail, charCount, currency }) => { return {selectedStyle, selectedVar, selectedDetail, charCount, currency} }
		)(this.state);
		
		newstate[attr] = val;
		
		if(val === -1) {
			newstate.selectedStyle = null;
		}
		
		if(attr === "selectedStyle") {
			newstate.selectedVar = null;
		}
		
		if(attr === "charCount" && (val < 1 || isNaN(val) || val > 100)) {
			newstate.charCount = 1;
		}
		
		if(newstate.selectedStyle && newstate.selectedVar !== null) {
			newstate.price = this.getPrice( newstate.selectedStyle, newstate.selectedVar, newstate.selectedDetail, newstate.charCount );
		} else newstate.price = 0;
		this.setState(newstate);
	}

	setCurrencyAndRate(currency, rate) {
		this.setState({
			...this.state, 
			currency: currency,
			rate: rate
		});
	}
	
	getPrice(style, variant, detail, charCount) {
		if(!style || !variant) return 0;
		
		let thisVariant = styles[style].variants[variant];
		return (
			thisVariant.base_price
		);
	}
	
	toggleLightbox() {
		this.setState( {lightboxOpen: !this.state.lightboxOpen} );
	}
}

export default App;